import React from 'react'
import { Link } from 'gatsby'
import { scroll_to } from '../lib/window'

const Navigation = ({ link_cls }) => {
  return (
    <div className="flex py-6">
      <div className="flex-grow flex-auto">&nbsp;</div>
      <div className="no-flex lg:flex w-3/4 text-xl font-bold">
        <div className="py-2 lg:py-0 flex-grow text-center"></div>
        <div className="py-2 lg:py-0 flex-grow text-center"><Link className={link_cls} to="/#shop" onClick={e => {
          if (typeof window !== 'undefined' && (window.location.hash === '#shop' || window.location.pathname === '/')) {
            e.preventDefault()
            scroll_to('.grid')
          }
        }}>SHOP</Link></div>
        <div className="py-2 lg:py-0 flex-grow text-center"><Link className={link_cls} to="/about">ABOUT</Link></div>
        <div className="py-2 lg:py-0 flex-grow text-center"><Link className={link_cls} to="/contact">CONTACT</Link></div>
        <div className="py-2 lg:py-0 flex-grow text-center"><Link className={link_cls} to="/scm">SUPPLY CHAIN MANAGEMENT</Link></div>
        <div className="py-2 lg:py-0 flex-grow text-center"><Link className={link_cls} to="/partners">PARTNERS</Link></div>
        <div className="py-2 lg:py-0 flex-grow text-center"><Link className={link_cls} to="/terms">TERMS</Link></div>
        <div className="py-2 lg:py-0 flex-grow text-center"><Link className={link_cls} to="/privacy">PRIVACY</Link></div>
      </div>
      <div className="flex-grow flex-auto">&nbsp;</div>
    </div>
  )
}

export default Navigation